module.exports = __webpack_public_path__ + "static/media/logo_rideflex_small.50362e0f.svg";